
import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/auth"; // Updated import
import { LoginForm } from "@/components/auth/LoginForm";
import { GoogleLoginButton } from "@/components/auth/GoogleLoginButton";
import { RedirectionOptions } from "@/components/auth/RedirectionOptions";
import { DashboardRedirectButton } from "@/components/auth/DashboardRedirectButton";
import { AuthDivider } from "@/components/auth/AuthDivider";

const Login = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [autoRedirect, setAutoRedirect] = useState(true); // Maintenant activé par défaut
  const navigate = useNavigate();
  const { user } = useAuth();

  // Si l'utilisateur est déjà connecté et la redirection automatique est activée
  useEffect(() => {
    if (user && autoRedirect) {
      // Vérifier si l'utilisateur doit configurer une organisation
      const needsOrgSetup = localStorage.getItem("needsOrgSetup");
      if (needsOrgSetup === "true") {
        navigate("/organization-setup");
      } else {
        navigate("/dashboard");
      }
    }
  }, [user, navigate, autoRedirect]);

  const handleLoginSuccess = () => {
    // Nous laissons la redirection automatique activée
    setAutoRedirect(true);
  };

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-pastel-blue-light px-4 sm:px-6 lg:px-8">
      <div className="w-full max-w-md space-y-8 rounded-xl bg-white p-8 shadow-md">
        <div className="text-center">
          <Link to="/" className="inline-block">
            <img src="/lovable-uploads/60f073cd-316e-4fa1-9add-c6553bdb9ac9.png" alt="Scaloo" className="h-10 mx-auto" />
          </Link>
          <h2 className="mt-6 text-3xl font-bold tracking-tight text-gray-900">
            Connexion à votre compte
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            Ou{" "}
            <Link
              to="/register"
              className="font-medium text-socialsync-600 hover:text-socialsync-500"
            >
              créez un nouveau compte
            </Link>
          </p>
        </div>

        <div className="mt-8 space-y-6">
          <LoginForm 
            onLoginSuccess={handleLoginSuccess} 
            isLoading={isLoading}
            setIsLoading={setIsLoading}
          />
          
          {/* Bouton de redirection manuelle - visible uniquement après connexion réussie */}
          <DashboardRedirectButton />

          <AuthDivider />

          <div className="mt-6">
            <GoogleLoginButton 
              isLoading={isLoading} 
              setIsLoading={setIsLoading} 
            />
          </div>
        </div>

        {/* Option pour activer/désactiver la redirection automatique */}
        <RedirectionOptions 
          autoRedirect={autoRedirect} 
          setAutoRedirect={setAutoRedirect} 
        />
      </div>
    </div>
  );
};

export default Login;
